module.exports = __webpack_public_path__ + "static/media/process_large.8fef1702.jpg";